import { deleteClientApi } from '../generated/clients/deleteClient';

const deleteClientCustomApi = deleteClientApi.enhanceEndpoints({
  endpoints: {
    deleteClient: {
      invalidatesTags: (_result, _error, { clientId }) => [
        { id: clientId, type: 'Clients' as const },
        { id: 'LIST', type: 'Clients' as const },
      ],
    },
  },
});

export const { useDeleteClientMutation } = deleteClientCustomApi;
